import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

// DTO for history page
export class CreditMovements extends Model {
  fromIdUser: number;
  fromLogin: string;
  toIdUser: number;
  toLogin: string;
  dateTime: string;
  superTosub: boolean;
  creditEatMode: number;
  credits: string;
  idMessageType: string;
  availableCredits: string;
  idPurchase: number;
  pricePerMessage?: Array<PricePerMessageCM>;
}

export class CreditMovementsList extends Paginated {
  data: Array<CreditMovements>;
}

// price per message dto
export class PricePerMessageCM extends Model {
  unitPrice: string;
  messageType: string;
}

/*
 * CREDIT_EAT_MODE: How to use credits, bit value:
 * 0x00: Own credit -> TYPE 2) -> real credit transfer
 * 0x01: Super account credit -> TYPE 1) -> no transfers
 * 0x02: Own credit and superaccount -> TYPE 3) -> virtual credit transfer
 */

export enum CreditEatMode {
  REAL_CREDITS = 0,
  VIRTUAL_CREDITS = 2,
  SUPERACCOUNT_CREDITS = 1
}
